var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36713 10.1L12.0171 4.45C12.1505 4.31667 12.3088 4.25 12.4921 4.25C12.6755 4.25 12.8338 4.31667 12.9671 4.45C13.1005 4.58333 13.1671 4.74167 13.1671 4.925C13.1671 5.10833 13.1005 5.26667 12.9671 5.4L6.8338 11.5333C6.70046 11.6667 6.54491 11.7333 6.36713 11.7333C6.18935 11.7333 6.0338 11.6667 5.90046 11.5333L3.0338 8.66667C2.90046 8.53333 2.83657 8.375 2.84213 8.19167C2.84769 8.00833 2.91713 7.85 3.05046 7.71667C3.1838 7.58333 3.34213 7.51667 3.52546 7.51667C3.7088 7.51667 3.86713 7.58333 4.00046 7.71667L6.36713 10.1Z",
    fill: "#3EAF3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.98d707f3f10e69a7216931e7e150778d.svg";
export { ForwardRef as ReactComponent };